export const customers = {
  title: "العملاء",
  description: "العملاء المحتملون والحسابات النشطة وسجلهم التجاري.",
  newCustomer: "عميل جديد",
  searchHint: "يطابق الاسم أو الرمز.",
  emptyTitle: "لا يوجد عملاء مطابقون",
  emptyDescription: "أنشئ عميلاً لبدء تسجيل عروض الأسعار وأوامر العمل والمتابعات.",
  notFound: "العميل غير موجود.",
  column: {
    name: "العميل",
    phone: "الهاتف",
    email: "البريد الإلكتروني",
    status: "الحالة",
  },
  statusOption: {
    activeAndLeads: "النشطون والعملاء المحتملون",
    leadsOnly: "العملاء المحتملون فقط",
    activeOnly: "النشطون فقط",
  },
  create: {
    title: "إضافة عميل",
    description: "يصبح العميل المحتمل نشطاً بمجرد بدء العمل التجاري.",
    button: "إنشاء العميل",
  },
  field: {
    legalName: "اسم الشركة",
    displayName: "الاسم المختصر",
    notesHint: "التفضيلات أو التوجيهات أو أي شيء ينبغي للورشة تذكّره.",
  },
  header: {
    back: "العودة إلى العملاء",
    reactivate: "إعادة تفعيل",
    archive: "أرشفة",
  },
  contacts: {
    title: "جهات الاتصال",
    add: "إضافة جهة اتصال",
    empty: "لا توجد جهات اتصال بعد.",
    saved: "حفظ جهة الاتصال",
    addedToast: "تمت إضافة جهة الاتصال",
    removedToast: "تمت إزالة جهة الاتصال",
  },
  addresses: {
    title: "العناوين",
    add: "إضافة عنوان",
    empty: "لا توجد عناوين بعد.",
    saved: "حفظ العنوان",
    addedToast: "تمت إضافة العنوان",
    removedToast: "تمت إزالة العنوان",
    labelHint: "مثال: بوابة الورشة، نقطة التسليم.",
  },
  tasks: {
    title: "المتابعات",
    schedule: "جدولة",
    empty: "لا توجد متابعات لهذا العميل.",
    scheduledToast: "تمت جدولة المتابعة",
    completedToast: "اكتملت المهمة",
    reopenedToast: "أُعيد فتح المهمة",
    reopen: "إعادة فتح",
    complete: "إكمال",
    dueTo: "مُسندة إلى {name}",
    dueAt: "تُستحق {date}",
    save: "حفظ المتابعة",
  },
  timeline: {
    title: "السجل الزمني",
    logActivity: "تسجيل نشاط",
    empty: "ستظهر المكالمات والاجتماعات والملاحظات هنا فور تسجيلها.",
    loggedToast: "تم تسجيل النشاط",
    taskCompleted: "مهمة مكتملة",
    taskScheduled: "مهمة مجدولة",
    whatHappened: "ماذا حدث؟",
    saveActivity: "حفظ النشاط",
  },
  followUps: {
    title: "متابعاتي",
    open: "{count} مفتوحة",
    emptyTitle: "لا شيء مستحق",
    emptyDescription: "ستصطف هنا المتابعات المسندة إليك لإكمالها.",
  },
  archivedToast: "تمت أرشفة العميل",
  reactivatedToast: "أُعيد تفعيل العميل",
  createdToast: "تم إنشاء العميل",
  createdToastDesc: "{name} مسجل في السجلات.",
};
